/**
 * WizardProgress — the step indicator across the top of the wizard.
 * Current step: purple · completed: green check · future: gray.
 */
import React from 'react';
import { Check } from 'lucide-react';
import { WIZARD_STEPS } from '../../constants/wizardSteps';

const WizardProgress = ({ currentIndex }) => (
  <div className="flex items-center justify-center gap-1 sm:gap-2 mb-8" data-testid="wizard-progress">
    {WIZARD_STEPS.map((step, i) => {
      const state = i < currentIndex ? 'done' : i === currentIndex ? 'current' : 'future';
      return (
        <React.Fragment key={step.id}>
          {i > 0 && (
            <div className={`w-6 sm:w-12 h-0.5 ${i <= currentIndex ? 'bg-emerald-400' : 'bg-gray-200'}`} />
          )}
          <div className="flex items-center gap-1.5" data-step-state={state}>
            <span
              className={`w-6 h-6 rounded-full text-[11px] font-bold flex items-center justify-center ${
                state === 'done'
                  ? 'bg-emerald-500 text-white'
                  : state === 'current'
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-100 text-gray-400'
              }`}
            >
              {state === 'done' ? <Check className="w-3.5 h-3.5" /> : i + 1}
            </span>
            <span
              className={`text-xs font-medium hidden sm:inline ${
                state === 'current' ? 'text-purple-700' : state === 'done' ? 'text-emerald-600' : 'text-gray-400'
              }`}
            >
              {step.title === 'Generation Settings' ? 'Generation' : step.title}
            </span>
          </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default WizardProgress;
